/**
 * Rutas a los assets servidos desde /public.
 * Vite publica el contenido de /public en la raíz del sitio.
 */
export const ASSETS = {
  hdri: '/assets/hdri/kloofendal_48d_partly_cloudy_puresky_2k.hdr',
  floor: {
    color: '/assets/textures/WoodFloor064/WoodFloor064_2K-JPG_Color.jpg',
    normal: '/assets/textures/WoodFloor064/WoodFloor064_2K-JPG_NormalGL.jpg',
    roughness: '/assets/textures/WoodFloor064/WoodFloor064_2K-JPG_Roughness.jpg',
  },
  /** Superficies de la base según el anclaje. */
  surfaces: {
    tarima: {
      color: '/assets/textures/WoodFloor064/WoodFloor064_2K-JPG_Color.jpg',
      normal: '/assets/textures/WoodFloor064/WoodFloor064_2K-JPG_NormalGL.jpg',
      roughness: '/assets/textures/WoodFloor064/WoodFloor064_2K-JPG_Roughness.jpg',
      repeat: 4,
    },
    hormigon: {
      color: '/assets/textures/Concrete034/Concrete034_2K-JPG_Color.jpg',
      normal: '/assets/textures/Concrete034/Concrete034_2K-JPG_NormalGL.jpg',
      roughness: '/assets/textures/Concrete034/Concrete034_2K-JPG_Roughness.jpg',
      repeat: 3,
    },
    cesped: {
      color: '/assets/textures/Grass001/Grass001_2K-JPG_Color.jpg',
      normal: '/assets/textures/Grass001/Grass001_2K-JPG_NormalGL.jpg',
      roughness: '/assets/textures/Grass001/Grass001_2K-JPG_Roughness.jpg',
      repeat: 6,
    },
  },
  font: '/assets/fonts/helvetiker_regular.typeface.json',
} as const;
